import type { MembershipsV1GetMembershipResponse } from '@sdk/Api'
import type { Writable } from '@square/svelte-store'
import { writable } from 'svelte/store'

export const membership: Writable<MembershipsV1GetMembershipResponse> = writable(null)
